import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.handleSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit)
  }

  async handleSubmit(event) {
    event.preventDefault()

    const form = this.element
    const email = form.querySelector('input[type="email"]').value.trim()
    const kind = form.querySelector('input[name="kind"]')?.value || "interested"
    const desiredDate = form.querySelector('input[name="desired_date"]')?.value || ""
    const errorBox = form.querySelector("#newsletter-subscription-error")

    if (errorBox) errorBox.innerHTML = ""
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]')
    if (submitButton) {
      submitButton.disabled = true
      submitButton.value = "Enviando..."
    }

    try {
      // A página vem do cache do Cloudflare: o token do HTML é de outra sessão
      const csrf = await this.freshCsrfToken()

      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: new URLSearchParams({ email, kind, desired_date: desiredDate, authenticity_token: csrf })
      })

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (e) {
      if (errorBox) errorBox.innerHTML = "<p class='newsletter-error'>Ocorreu um erro. Tente novamente.</p>"
    } finally {
      if (submitButton && document.contains(submitButton)) {
        submitButton.disabled = false
        submitButton.value = "Quero receber aviso"
      }
    }
  }

  async freshCsrfToken() {
    const response = await fetch("/csrf_token", { headers: { "Accept": "application/json" }, credentials: "same-origin" })
    return (await response.json()).token
  }
}